import { graphql } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RoutingQuery } from '../../../graphql-types';
import Seo from '../../components/seo';
import useRedirect from '../../hooks/redirect';
import { TPageProps } from '../../page-props';

function RoutingPage(props: TPageProps<RoutingQuery>) {
  const {
    pageContext: { slug },
    location: { search },
  } = props;
  const { t } = useTranslation();

  useRedirect({ slug, search });

  return (
    <Seo
      isRoot
      description={
        props.data.prismicRouting?.data.description?.text ||
        t('geovelo.pages_descriptions.routing') ||
        null
      }
      title={`${props.data.prismicRouting?.data.title?.text || t('geovelo.pages_titles.routing')}`}
      {...props}
    />
  );
}

export default RoutingPage;

export const query = graphql`
  query Routing($lang: String) {
    prismicRouting(lang: { eq: $lang }) {
      _previewable
      data {
        title {
          text
        }
        description {
          text
        }
      }
    }
  }
`;
